import { Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  host: { 'data-cid': 'grid-empty-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  standalone: true,
  template: '',
})
export class GridEmptyCellComponent implements ICellRendererAngularComp {
  agInit(_params: ICellRendererParams): void {}

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
